import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { breakpoints } from '../ModalUpsell.styles';

const Box = styled.div`
  background: #fff;
  color: '#575756';
  font-size: ${rem(12)};
  line-height: ${`${rem(10)}`};
  box-shadow: 0 ${rem(2)} ${rem(9)} rgba(0, 0, 0, 0.08);
  border-radius: ${rem(3)};
  padding: ${rem(12)} ${rem(10)};
  margin-top: 18px;
  display: flex;
  align-items: center;
  + div {
    margin-top: ${rem(4)};
  }
  svg {
    margin-right: ${rem(6)};
  }

  @media only screen and (min-width: ${breakpoints.mobile}) {
    font-size: ${rem(9)};
    padding: ${rem(8)} ${rem(10)};
  }
`;

const PostiveSvgIcon = () => (
  <svg width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Score influencer positive icon</title>
    <circle cx="6.508" cy="6.369" r="5.838" stroke="#00AA4B" strokeWidth="1.062" />
    <path d="m3.323 6.37 2.123 2.122 4.246-4.246" stroke="#00AA4B" strokeWidth="1.062" />
  </svg>
);

const NegativeSvgIcon = () => (
  <svg width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Score influencer negative icon</title>
    <path
      d="m6.94 4.777-.068 3.85h-.73l-.07-3.85h.869Zm-.435 5.454a.512.512 0 0 1-.372-.153.51.51 0 0 1-.155-.374.5.5 0 0 1 .155-.37.508.508 0 0 1 .372-.156c.145 0 .269.052.372.156a.5.5 0 0 1 .156.37.51.51 0 0 1-.156.374.512.512 0 0 1-.372.153Z"
      fill="#E21C77"
    />
    <path
      d="M11.685 11.677H1.33a.177.177 0 0 1-.156-.262l5.177-9.491a.177.177 0 0 1 .311 0l5.177 9.491a.177.177 0 0 1-.155.262Z"
      stroke="#E21C77"
      strokeWidth="1.062"
    />
  </svg>
);

const CEScoreInfluencers = () => (
  <React.Fragment>
    <Box className="positive">
      <PostiveSvgIcon />
      Positive
    </Box>
    <Box className="negative">
      <NegativeSvgIcon />
      Negative
    </Box>
  </React.Fragment>
);

export default CEScoreInfluencers;
